<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TkCaz/tc-custom/9781429975537.jpg?1737774768149" alt="This image is the cover for the book Murcheston"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murcheston
      </h1>
      <p class="bookDescription body article font2">
        <p>Shrouded within the dark corners of imagination, the werewolf holds a supreme place in fable and folklore-the nightbeast, stalking its prey under the light of a full moon. Such is the popular conception. But what of the beast himself? In the novel The Wolf's Tale, a werewolf documents his own case of lycanthropy. Amid the gothic backdrop of Victorian London, the author presents three gentlemen and one woman as they share the telling of this tale-the tale of Edgar Lenoir, Duke of Darnley: aristocrat and werewolf.<br/><br/>When Lord Darnley learns that Elizabeth is pregnant with Merry's baby, he plans a hunt in the Carpathian Mountains to escape the pain of his unrequited love. Darnely goes alone and returns a changed man . . . a man who will then change Merry's and Elizabeth's lives forever.<br/><br/>The centerpiece of the novel is Lord Darnley's journal chronicling his months as a werewolf. He views his condition not with horror, but with a fascination he believes to be thoroughly modern. Unfortunately, he is also narcissistic, ruthless, and ultimately, seduced by his own misguided self-interest to justify as natural and healthy the bestial desires that eventually consume him.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Holland
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b7da397